export default "__VITE_PUBLIC_ASSET__65bc46f6__"